import React from 'react';
import { BellRing as LucideBellRing } from 'lucide-react';

interface BellRingProps {
  width?: number;
  height?: number;
  className?: string;
  style?: React.CSSProperties;
}

const BellRing: React.FC<BellRingProps> = ({ width = 24, height = 24, className, style }) => (
  <LucideBellRing width={width} height={height} className={className} style={style} aria-hidden strokeWidth={1.75} />
);

export default BellRing;
